export default "__VITE_ASSET__K73A0xuO__"